module.exports = __webpack_public_path__ + "static/img/group.884b5f2c.png";